{
  "downloadIos": "Télécharger pour iPhone",
  "downloadAndroid": "Télécharger pour Android"
}
